import { Component, OnInit } from '@angular/core';
import { Travel } from 'src/app/models/travel';
import { TravelService } from 'src/app/services/travel.service';
import { ActivatedRoute } from '@angular/router';
import { TravelLine } from 'src/app/models/travel-line';
import { Driver } from 'src/app/models/driver';
import { DriverService } from 'src/app/services/driver.service';

@Component({
  styleUrls: ['./gas-ticket.component.css'],
  selector: 'app-gas-ticket',
  templateUrl: './gas-ticket.component.html',
})
export class GasTicketComponent implements OnInit {

  travel:Travel = new Travel();
  lines:TravelLine[] = [];
  firstLineNonEmpty:TravelLine = new TravelLine;
  latestLineId:number = 0;
  loading:boolean = false;
  lts:number = 0;
  first:boolean = false;

  isFull:number = 1;
  driver:Driver = new Driver()

  showFake:boolean = true;

  constructor(private travelServ:TravelService, actRoute:ActivatedRoute, private dirverServ:DriverService) {
    this.loading = true;

    actRoute.params.subscribe(params => {
      if (params.ticket) {
        this.travelServ.postGasTicket(params.id, params.ticket)
          .then(res => {
            return this.travelServ.getTravel(params.id);
          }).then(tr => {
            this.travel = tr;
  
            this.lts = this.travel.expenses
              .filter(exp => exp.expense_name == 'SUPER DIESEL' || exp.expense_name == 'EXTRA GASOLINA')
              .map(exp => exp.quantity)
              .reduce((ant, act) => {
                return Number(ant) + Number(act);
              }, 0);
  
              this.firstLineNonEmpty = this.nonEmpty(this.travel.lines)[0];
              this.dirverServ.getDriver(this.travel.operator_id)
                .then(driver => {
                  this.driver = driver;
                  this.loading = false;
                });
          });
      } else {
        this.travelServ.getTravel(params.id)
          .then(tr => {
            this.travel = tr;
            this.isFull = this.travel.unity_id != null && this.travel.trailer_1_id != null && this.travel.trailer_2_id && this.travel.trailer_3_id != null ? 2 : 1;
            this.lines = tr.lines.filter(line => line.presentation_name != 'Vacio');
            this.latestLineId = tr.lines[tr.lines.length - 1].id;
  
            this.lts = this.travel.expenses
              .filter(exp => exp.expense_name == 'SUPER DIESEL' || exp.expense_name == 'EXTRA GASOLINA')
              .map(exp => exp.quantity)
              .reduce((ant, act) => {
                return Number(ant) + Number(act);
              }, 0);
  
            this.firstLineNonEmpty = this.nonEmpty(this.travel.lines)[0];
            this.dirverServ.getDriver(this.travel.operator_id)
              .then(driver => {
                this.driver = driver;
                this.loading = false;
              });
          });
      }
    });
  }

  ngOnInit() {
  }

  isSalto(i, j) {
    if (j == 0) {
      return i % 2 == 0
    } else {
      if (this.lines.length % 2 == 0) {
        return i % 2 == 0
      } else {
        return i % 2 != 0
      }
    }
  }

  nonEmpty(lines:TravelLine[]) {
    return lines.filter(x => x.presentation_name != 'Vacio');
  }

  sumData(lines:TravelLine[], property) {
    return this.nonEmpty(lines).map(x => Number(x[property])).reduce((x, y) => x + y, 0);
  }

  existProducts(lines:TravelLine[], products:string[]) {
    return this.nonEmpty(lines).find(x => products.find(y => y == x.product_name) ? true : false);
  }

  canShowFake(line) {
    return (line.ton > 25 && this.travel.unity.unit_type_id == 1) || (line.ton > 10 && (this.travel.unity.unit_type_id == 8 || this.travel.unity.unit_type_id == 9 || this.travel.unity.unit_type_id == 10)) || (line.ton > 3.5 && this.travel.unity.unit_type_id == 12)
  }

  getFakeTon(line = null) {
    return this.travel.unity.unit_type_id == 1 ? 24.3 : 
      (this.travel.unity.unit_type_id == 8 || this.travel.unity.unit_type_id == 9 || this.travel.unity.unit_type_id == 10 ? 9.45 : 
        (this.travel.unity.unit_type_id == 12 ? 3.2 : line.ton));
  }
}
